export default "__VITE_ASSET__CxMHh8Xn__"